import { render, staticRenderFns } from "./ClinicalHistory.vue?vue&type=template&id=3a8dc906"
import script from "./ClinicalHistory.vue?vue&type=script&lang=js"
export * from "./ClinicalHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports